import Vue from 'vue'
import serviceItemDialogSelector from './serviceitem-dialog-selector.vue'
import ServiceItemDialogSelectorInstance from './serviceitem-dialog-selector-instance.vue'

serviceItemDialogSelector.install = function (Vue) {
	Vue.component(serviceItemDialogSelector.name, serviceItemDialogSelector);
}

export default serviceItemDialogSelector;
class ServiceItemInstance {
	constructor() {
		this.instance = null;
	}
	init() {
		// 初始化实例，挂载dom
		const VueInstance = Vue || window.Vue;
		let ServiceItemInstance = VueInstance.extend(ServiceItemDialogSelectorInstance);
		this.instance = new ServiceItemInstance({
			el: document.createElement('div'),
		}).$mount();
		document.body.appendChild(this.instance.$el);
	}
	getInstance() {
		// 返回实例
		return this.instance;
	}
	// 外部调用方法
	show(params) {
		return new Promise((resolve, reject) => {
			if (!this.instance) {
				this.init();
			}
			Object.assign(this.instance, {resolve, reject})
			this.instance.show(params);
		})
		
	}
}

export const ServiceItemSelectModal = new ServiceItemInstance();
window.serviceItemSelectModal = ServiceItemSelectModal;